<div id="start_order">
  <div class="col-xs-12 col-md-12 col-lg-12  main">
    <!-- Banner starts -->
    <section class="col-xs-12 cart_titlesection">
      <div class="col-sm-12 col-xs-12 col-lg-8">
        <h1 class="cart_header">{{'startOrder.mycarttitle' | cxTranslate}}</h1>
        <div class="cart_subheader"></div>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-4 cart_dateheader">
        <div>{{bannerContent.headline}}</div>
        <div class="cart_sub_header">{{bannerContent.h2content}}</div>
      </div>
    </section>
    <!-- Banner ends -->


    <!-- Title starts -->
    @if (!showThankYouContent) {
      <section class="col-xs-12 cart_neworder">
        <div class="col-xs-12 d-md-block d-lg-block d-xl-block d-none d-xs-none d-sm-none pl-0 pr-0">
          <div class="neworder_Container">
            <div class="col-md-6 col-lg-6 col-xl-6 cart_neworderheader">{{'startOrder.newordertxt' | cxTranslate}}</div><br/>
            <!-- trigger stays exactly same -->
            <!--Shipment Flexibilty Calendar start-->
            <!-- <div *ngFor="let item of items; let i = index">
            <div class="selected-date">
              Selected delivery date:
              <input
                class="date-box"
                type="text"
                [value]="confirmedDates[i] | date: 'EEEE, MMMM d, y'"
                readonly
                />
              </div>
              <span
                class="reschedule-link"
                (click)="openCalendar(i, $event)">
                Reschedule delivery
              </span>
              <div
                class="calendar-wrapper"
                *ngIf="openCalendarIndex === i"
                (click)="$event.stopPropagation()"
                >
                <div class="custom-month-label">
                  {{ monthLabel }}
                </div>
                <mat-calendar
                  #calendar
                  [minDate]="minSelectableDate"
                  [maxDate]="maxSelectableDate"
                  [dateFilter]="dateFilter"
                  [selected]="tempSelectedDates[i]"
                  (selectedChange)="onDateSelected(i, $event)"
                  >
                </mat-calendar>
                <div class="calendar-info">
                  <mat-icon>info</mat-icon>
                  {{ deliveryConfig.infoText }}
                </div>
                <button
                  mat-stroked-button
                  color="primary"
                  [disabled]="!tempSelectedDates[i]"
                  (click)="confirmDate(i)"
                  >
                  Update Delivery
                </button>
              </div>
              <br/>
            </div> -->
            <!--Shipment Flexibilty Calendar Ends-->
            <div class="col-md-6 col-lg-6 col-xl-6 need_help_content pr-0">
              @if (needHelpContent | async; as item) {
                <div class="startuserguideparent need_help_container pr-0"
                  >
                  <span class="userguidegrey">{{item.headline}}</span>
                  <a class="userguideanchor" [href]="getImage(item.media)" target="_blank"><span
                  class="userguideblack anchorunderline">{{item.h2content}}</span>
                </a>
                <span class="blackarrow"></span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-12 col-xs-12 col-sm-12 d-block d-sm-block d-md-none d-lg-none d-xl-none pr-0">
        @if (needHelpContent | async; as item) {
          <div class="startmobuserguideparent">
            <span class="userguidegrey">{{item.headline}}</span><a class="userguideanchor"
            [href]="getImage(item.media)" target="_blank"><span
          class="userguideblack">{{item.h2content}}</span>
        </a>
        <span class="blackarrow"></span>
      </div>
    }
  </div>
  <div
    class="col-12 col-xs-12 col-sm-12 d-block d-sm-block d-md-none d-lg-none d-xl-none cart_neworderheader">
  {{'startOrder.newordertxt' | cxTranslate}}</div>
  <!-- <div class="cart_delete hidden"><div class="global_blackarrow"></div><span>Delete Cart &amp; Start New Order</span></div>
  <div class="col-xs-12 col-md-12 cart_TIValert hidden">
    <div class="attention_header">Attention:</div>
    <div>New and existing 2024-2025 pre-book orders will be fulfilled in trivalent product formulations. No action is needed from you.<br> <a href="/digital_customer_letter_tiv_vaccines_24-25" target="_blank">Read our full Customer Letter<img alt="" class="padding-L5" src="_ui/responsive/theme-lambda/images/red_arrow.png"></a></div>
  </div> -->
  @if (orderLists?.orderBlock) {
<div class="col-xs-12 col-md-12 col-lg-12 orderblock
    " >
      {{'startOrder.orderblockmsg' | cxTranslate}}
      <div> <a href="mailto:USAINC.AccountsReceivable@Seqirus.com" [innerHTML]="'USAINC.AccountsReceivable@Seqirus.com.'"></a></div></div>
    }
  @if (showPrePaymentDeclinedMessage) {
    <div class="col-xs-12 col-md-12 col-lg-12 orderblock prePayment_declined_msg" [innerHTML]="prePaymentTermsAcceptDescription">
    </div>
  }
    @if (!orderLists?.orderBlock) {
      <div class="d-md-none d-lg-block d-xl-block d-none d-xs-none d-sm-none">
        @if (orderLists) {
          <div class="col-xs-12 cart_neworderbtns pr-0"
            [ngClass]="!seasonValue ? 'order_box' : ''">
            @if (orderLists.preSeasonEnable) {
              <div class="col-xs-4 pl-0 pr-0 mr-4" id="cart_neworderbtn-1">
                <button class="col-xs-12 cart_neworderbtn" (click)="handleOnSeasonBtnClick('prebook')"
                  [ngClass]="seasonValue === 'prebook'? 'cart_active': 'disable_cart'">
                  <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.reserveforlabel' | cxTranslate}}
                  </div>
                  <!-- <div class="col-xs-12 cart_neworderbtndate">{{'startOrder.sesonterm2text' | cxTranslate}}
                </div> -->
                <div class="col-xs-12 cart_neworderbtndate">{{orderLists.preSeasonYear?.replace('-',' - ')}} Season
                </div>
              </button>
            </div>
          }
          @if (orderLists.inSeasonEnable) {
            <div class="col-xs-4 pl-0 pr-0" id="cart_neworderbtn-2">
              <button class="col-xs-12 cart_neworderbtn" (click)="handleOnSeasonBtnClick('inSeason')"
                [ngClass]="seasonValue === 'inSeason' ? 'cart_active': 'disable_cart'">
                <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.orderfortext' | cxTranslate}}
                </div>
                <!-- <div class="col-xs-12 cart_neworderbtndate">{{'startOrder.sesonterm1text' | cxTranslate}}
              </div> -->
              <div class="col-xs-12 cart_neworderbtndate">{{orderLists.inSeasonYear?.replace('-',' - ')}} Season
              </div>
            </button>
          </div>
        }
        <div class="col-xs-4 pl-0 pr-0 ml-4" id="cart_neworderbtn-3"
          (click)="handleOnSeasonBtnClick('bulkOrder')">
          <button class="col-xs-12 cart_neworderbtn" data-bs-toggle="collapse"
            data-bs-target="#cart_selectlocation-3"
            [ngClass]="{'cart_active': seasonValue === 'bulkOrder', 'disable_cart': seasonValue !== 'bulkOrder', 'cart_btn_disabled': showPrePaymentDeclinedMessage || checkPrePaymentCustomer()}">
            <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.orderviatext' | cxTranslate}}
            </div>
            <div class="col-xs-12 cart_neworderbtndate">{{'startOrder.fileuploadtext' | cxTranslate}}
            </div>
          </button>
        </div>
      </div>
    }
  </div>
  @if (orderLists) {
    <div class="col-12 col-xs-12 col-sm-12 d-block d-sm-block d-md-block d-lg-none d-xl-none cart_neworderbtns pr-0 mt-0"
      >
      <div class="global_selectdivmob">
        <select name="cart_neworderselect" id="cart_neworderselect" [(ngModel)]="mobileSeasonValue"
          (change)="handleOnSeasonBtnClick('mobile')">
          <option selected value="Select New Order Type" id="cart_neworderselect-0" disabled>
            {{'startOrder.selectnewordtypetext'
          | cxTranslate}}</option>{{'startOrder.reserveforlabel' | cxTranslate}}
          @if (orderLists.preSeasonEnable) {
            <option value="prebook" id="cart_neworderselect-1">
            {{orderLists.preSeasonYear?.replace('-',' - ')}} Season</option>
          }
          @if (orderLists.inSeasonEnable) {
            <option value="inSeason" id="cart_neworderselect-2">
            {{orderLists.inSeasonYear?.replace('-',' - ')}} Season</option>
          }
          <option value="bulkOrder" id="cart_neworderselect-3"
          [disabled]="checkPrePaymentCustomer()">{{'startOrder.fileuploadtext' |
            cxTranslate}}
          </option>
        </select>
      </div>
    </div>
  }
} @else {
  <div class="d-md-none d-lg-block d-xl-block d-none d-xs-none d-sm-none">
    @if (orderLists) {
      <div class="col-xs-12 cart_neworderbtns pr-0"
        >
        @if (orderLists.preSeasonEnable) {
          <div class="col-xs-4 pl-0 pr-0 mr-4" id="cart_neworderbtn-1">
            <button class="col-xs-12 cart_neworderbtn"
              >
              <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.reserveforlabel' | cxTranslate}}
              </div>
              <div class="col-xs-12 cart_neworderbtndate">{{orderLists.preSeasonYear?.replace('-',' - ')}} Season
              </div>
            </button>
          </div>
        }
        @if (orderLists.inSeasonEnable) {
          <div class="col-xs-4 pl-0 pr-0" id="cart_neworderbtn-2">
            <button class="col-xs-12 cart_neworderbtn"
              >
              <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.orderfortext' | cxTranslate}}
              </div>
              <div class="col-xs-12 cart_neworderbtndate"> {{orderLists.inSeasonYear?.replace('-',' - ')}} Season
              </div>
            </button>
          </div>
        }
        <div class="col-xs-4 pl-0 pr-0 ml-4" id="cart_neworderbtn-3"
          >
          <button class="col-xs-12 cart_neworderbtn" data-bs-toggle="collapse"
            data-bs-target="#cart_selectlocation-3"
            >
            <div class="col-xs-12 cart_neworderbtnheader">{{'startOrder.orderviatext' | cxTranslate}}
            </div>
            <div class="col-xs-12 cart_neworderbtndate">{{'startOrder.fileuploadtext' | cxTranslate}}
            </div>
          </button>
        </div>
      </div>
    }
  </div>
  @if (orderLists) {
    <div class="col-12 col-xs-12 col-sm-12 d-block d-sm-block d-md-block d-lg-none d-xl-none cart_neworderbtns pr-0 mt-0"
      >
      <div class="global_selectdivmob">
        <select name="cart_neworderselect" id="cart_neworderselect" [(ngModel)]="mobileSeasonValue"
          >
          <option selected value="Select New Order Type" id="cart_neworderselect-0" disabled>
            {{'startOrder.selectnewordtypetext'
          | cxTranslate}}</option>{{'startOrder.reserveforlabel' | cxTranslate}}
          @if (orderLists.preSeasonEnable) {
            <option value="prebook" id="cart_neworderselect-1">
            {{orderLists.preSeasonYear?.replace('-',' - ')}} Season</option>
          }
          @if (orderLists.inSeasonEnable) {
            <option value="inSeason" id="cart_neworderselect-2">
            {{orderLists.inSeasonYear?.replace('-',' - ')}} Season</option>
          }
          <option value="bulkOrder" id="cart_neworderselect-3"
          [disabled]="checkPrePaymentCustomer()">{{'startOrder.fileuploadtext' |
            cxTranslate}}
          </option>
        </select>
      </div>
    </div>
  }
}
</section>
}
@if (orderLists && orderLists.validForRebook && !showThankYouContent && !showBulkOrderSection && !hidereorder) {
  <div class="col-xs-12 cart_neworderreorder prebookrolloverlink cart_summary_reorder_section"
    (click)="handleOnReorderClick();scrollToTop()">{{'startOrder.reorderqtytxt' | cxTranslate}}
    <div class="global_blackarrow"></div>
  </div>
}
<!-- Titles ends -->

<!--Loader icons-->
@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">Loading</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
<!----Loader ends here----->

<!-- Membership starts -->
@if (showMembershipContent && orderLists) {
  <div>
    <section class="col-xs-12 col-md-12 cartmembercontainer">
      <form id="cartMemberform" #memberForm="ngForm"
        (ngSubmit)="memberForm.form.valid && handleOnFormSubmit(memberForm.value,orderLists)">
        <div class="col-xs-12 cart_memberbox membership_Cart_MemberBox">
          <div>
            <div class="col-xs-12 memberheader memberheadercolor">{{'startOrder.memebership.title' | cxTranslate}}</div>
            <div class="col-xs-12 memberline"></div>
            <div class="col-xs-12 no-padding memberquestionsection">
              <!-- <input type="hidden" value="flu360 Pricing" name="currentMembership"> -->
              <div class="col-xs-12 memberdetails margin-B30">{{'startOrder.memebership.currmembershiptxt' | cxTranslate}}<span
              class="membername">&nbsp;{{orderLists.membershipData.currentMembership}}</span>
            </div>
            <div class="col-xs-12 cart_questionheader">{{'startOrder.memebership.qstn' | cxTranslate}}
            </div>
            <div class="col-xs-12 membership_subheader"><!-- {{'startOrder.memebership.confirmmsg' | cxTranslate}} -->
            </div>
            <div class="col-xs-12 memberradiocontainer">
              <input type="radio" name="membershipDecision" class="memberradiobtn"
                id="memberradiobtn1" value="yes" #membershipDecision="ngModel"
                [(ngModel)]="orderLists.membershipData.membershipDecision"
                required [disabled]="!fieldsetDisabled">
                <span class="radio-button__control"></span>
                <label for="memberradiobtn1">{{'startOrder.memebership.yeslabel' | cxTranslate}}</label>
              </div>
              <div class="col-xs-12 memberradiocontainer">
                <input type="radio" name="membershipDecision" class="memberradiobtn"
                  id="memberradiobtn2" value="no" #membershipDecision="ngModel"
                  [(ngModel)]="orderLists.membershipData.membershipDecision" required
                  [disabled]="!fieldsetDisabled">
                  <span class="radio-button__control"></span>
                  <label for="memberradiobtn2">{{'startOrder.memebership.nolabel' | cxTranslate}}</label>
                </div>
                <div class="col-md-5 col-xs-11 addmemberfield">
                  <label class="cartmember_inputLabel" for="memberinput">{{'startOrder.memebership.buyinggrpheadline' | cxTranslate}}</label>
                  <input type="text" #membershipData="ngModel" [(ngModel)]="requestedMembership"
                    class="cartmember_input form-control" id="memberinput"
                    name="requestedMembership" placeholder="Enter Buying Group Organization Name"
                    [disabled]="membershipDecision.value != 'no' || !fieldsetDisabled"
                    autocomplete="no" required>
                    <span class="glyphicon  form-control-feedback" [ngClass]="memberForm.invalid && memberForm.touched?'glyphicon-exclamation-sign':''"></span>
                    <div class="membererrortext">@if (memberForm.invalid && memberForm.touched) {
                      {{'startOrder.memebership.buyinggrperrormsg' | cxTranslate}}
                    }</div>
                  </div>
                  <div class="clearboth"></div>
                  <div class="col-xs-12 memberradiocontainer">
                    <input type="radio" name="membershipDecision" class="memberradiobtn"
                      id="memberradiobtn3" value="notsure" #membershipDecision="ngModel"
                      [(ngModel)]="orderLists.membershipData.membershipDecision"
                      required [disabled]="!fieldsetDisabled">
                      <span class="radio-button__control"></span>
                      <label for="memberradiobtn3">{{'startOrder.memebership.notsurelabel' | cxTranslate}}</label>
                    </div>
                    <div class="clearboth"></div>
                    <button type="submit" class="membersubmitbtn" id="memberSubmitbtn"
                      [disabled]="!memberForm.valid || !fieldsetDisabled">
                      <!-- [disabled]="!fieldsetDisabled || !membershipDecision.value || (membershipDecision.value === 'no' && !requestedMembership)"> -->
                    {{'startOrder.memebership.submitlabel' | cxTranslate}}</button>
                    @if (yesContent) {
                      <div class="col-xs-12 memberThankyou yescontractsign"
                        [ngClass]="!fieldsetDisabled && membershipDecision.value === 'yes' ? 'showContent' : ''">
                        @if (!fieldsetDisabled && membershipDecision.value === 'yes') {
                          <div [innerHTML]="yesContent.content"
                            >
                          </div>
                        }
                      </div>
                    }
                    @if (noContent) {
                      <div class="col-xs-12 memberThankyou nosubmit"
                        [ngClass]="!fieldsetDisabled && membershipDecision.value === 'no' ? 'showContent' : ''">
                        @if (!fieldsetDisabled && membershipDecision.value === 'no') {
                          <div>
                            <div [innerHTML]="noContent.content"></div>
                            <div>{{noContent.headline}}&nbsp;{{orderLists.membershipData.currentMembership}}
                            </div>
                            <div [innerHTML]="noContent.h2content"></div>
                            <div [innerHTML]="noContent.h3content"></div>
                          </div>
                        }
                      </div>
                    }
                    @if (notSureContent) {
                      <div class="col-xs-12 memberThankyou notsurecontractsign"
                        [ngClass]="!fieldsetDisabled && membershipDecision.value === 'notsure' ? 'showContent' : ''">
                        @if (!fieldsetDisabled && membershipDecision.value === 'notsure') {
                          <div
                          [innerHTML]="notSureContent.content"></div>
                        }
                      </div>
                    }
                    <div class="col-xs-12 memberline memberlinebottom "></div>
                    <div class="clearboth"></div>
                  </div>
                  <div class="col-xs-12 startorderbtn">
                    @if (fieldsetDisabled) {
                      <button type="submit" class="membersubmitbtn"
                      id="memberSubmitbtn" [disabled]="true">{{'startOrder.startordertxt' | cxTranslate}}</button>
                    }
                    @if (!fieldsetDisabled) {
                      <button type="submit" class="enablestrtbtn"
                      id="memberSubmitbtn" (click)="handleOnStartOrderBtnClick();scrollToTop()">{{'startOrder.startordertxt' | cxTranslate}}</button>
                    }
                  </div>
                </div>
              </div>
            </form>
          </section>
        </div>
      }
      <!-- Membership ends -->

      <!-- Location starts -->
      @if (showLegacyLocationPage && showLocationContent && orderLists) {
        <div>
          <section class="col-xs-12 col-md-12 cart_selectlocations mt-2">
            <div class="col-xs-12 cart_memberbox location_box">
              <div>
                <div class="col-xs-12 col-md-6 cart_selectheader">{{'startOrder.selectloctxt' | cxTranslate}}</div>
                <div class="col-xs-12 col-md-6 cart_selectcount">{{'startOrder.ordertotxt' | cxTranslate}}@if (searchText.value === '') {
                  <span class="cart_loccount"
                  >{{selection.selected.length}} </span>
                }
                <span>{{'startOrder.locslabel' | cxTranslate}}</span>
              </div>
              <div class="col-xs-12 cart_selectline"></div>
              <div class="col-xs-12 cart_selectoptions">
                <div class="cart_customsearch">
                  <i class="global_searchicon"></i><input type="search" #searchText
                  (keyup)="$event.keyCode == 13 ? applyFilter(searchText.value) : null"
                  placeholder="Search for location" id="cart_searchbox"><button (click)="applyFilter(searchText.value)">{{'startOrder.searchlabel' | cxTranslate}}</button>
                </div>
                <div class="cart_selectunselect">
                  <div class="cart_selectoption" id="cart_selectall"
                  (click)="handleOnSelectAllBtnClick()">{{'startOrder.selectall' | cxTranslate}}</div>
                  <div class="cart_selectdivision"></div>
                  <div class="cart_selectoption" id="cart_clearall" (click)="handleonclearbtnclick()">
                  {{'startOrder.clearselection' | cxTranslate}}</div>
                </div>
              </div>
            </div>
            <!-- Table starts here-->
            <div class="tablecontainer pr-3">
              <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="locID">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element"> {{element.locname}} </td>
                </ng-container>
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                </ng-container>
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element"> {{element.state}} </td>
                </ng-container>
                <ng-container matColumnDef="orderExists">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="order_loc">
                      @if (seasonValue === 'prebook'?element.preBookOrderExists:element.orderExists) {
                        <div class="cart_existingorder">{{'startOrder.orderexistmsg1' | cxTranslate}}<span class="cart_orderNavigate"
                        (click)="handleMyOrdersLink(element.address)">{{'startOrder.myordertxt' | cxTranslate}}</span>{{'startOrder.orderexistmsg2' | cxTranslate}}</div>
                      }
                      <div class="selectedtick"></div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="handleOnRowClick(row)"
                [ngClass]="selection.isSelected(row) || row.selected ? 'selected' : ''"></tr>
              </table>
            </div>
            <!-- Table ends -->
            <div class="col-xs-12 cart_selectline abovebtnselectline"></div>
            <div class="col-xs-12 cart_startorderbtnsection">
              <button class="cart_startorderbtn" id="inSeason" [disabled]="!(selection.selected.length > 0)"
              (click)="handleOnSelectProductClick();scrollToTop()">{{'startOrder.selectprodtxt' | cxTranslate}}</button>
            </div>
          </div>
        </section>
      </div>
    }

    <!-- Product page starts -->
    @if ( showLegacyProductPage && showProductContent && orderLists) {
      <div class="col-xs-12" id="cart_section" >
        <div class="col-xs-12 col-md-12 add_cart_wrapper" id="cart-wrapper-main">
          <div class="row">
            <div class="col-md-12 border_cart">
              <div class="cart_summaryProductselection anchorunderline locationContainer"
                (click)="handleOnBackToLocationBtnClick();scrollToTop()">
                <div class="global_blackarrow"></div>{{'startOrder.backtoloctxt' | cxTranslate}}
              </div>
              <!-- Mmbership content starts -->
              @if (orderLists && (orderLists.membershipData.membershipStatus == 'Active') && !showPendingMessage) {
                <div class="col-xs-12 no-padding pending"
                  >
                  <div class="col-xs-12 topline"></div>
                  @if (quantityincreased) {
                    <div class="greenbox col-xs-12 ">
                      <span class="quantitytext">{{'startOrder.thankincrease' | cxTranslate}}</span>
                      <span class="thanktext">{{'startOrder.protectedtext' | cxTranslate}}</span>
                      <span class="undo">(</span>
                      <span class="undo" (click)="handleonUndo()">{{'startOrder.undo' | cxTranslate}}</span>
                      <span class="undo">)</span>
                    </div>
                  }
                  @if (activeMembershipContent) {
                    <div class="col-xs-12 productmemberdetails reviewpagemembership">
                      <p>
                        {{activeMembershipContent.title}}&nbsp;<strong>{{orderLists.membershipData.currentMembership}}.</strong>
                      </p>
                      <p>{{pendingMembershipContent.text2}}</p>
                      @if (!isModelnSuccess) {
                        <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="active_Member_Boldtxt">{{activeMembershipContent.text1}}</strong></p>
                      }
                      @if (isModelnSuccess) {
                        <div [innerHTML]="activeMembershipContent.content"></div>
                      }
                      @if (!isModelnSuccess) {
                        <div class="price_detail" [innerHTML]="activeMembershipContent.text2"></div>
                      }
                    </div>
                  }
                </div>
              }
              @if (orderLists && orderLists.membershipData.membershipStatus == 'Pending' || showPendingMessage) {
                <div class="col-xs-12 no-padding pending"
                  >
                  <div class="col-xs-12 topline"></div>
                  @if (quantityincreased) {
                    <div class="greenbox col-xs-12 ">
                      <span class="quantitytext">{{'startOrder.thankincrease' | cxTranslate}}</span>
                      <span class="thanktext">{{'startOrder.protectedtext' | cxTranslate}}</span>
                      <span class="undo" (click)="handleonUndo()">{{'startOrder.undo' | cxTranslate}}</span>
                    </div>
                  }
                  @if (pendingMembershipContent) {
                    <div class="col-xs-12 productmemberdetails reviewpagemembership">
                      <p>{{pendingMembershipContent.title}}</p>
                      <p>{{pendingMembershipContent.text2}}</p>
                      @if (isModelnSuccess) {
                        <p>
                          Prices shown reflect current
                          @if (orderLists.membershipData.currentMembership != 'flu360 Pricing') {
                            <span>{{orderLists.membershipData.currentMembership}} pricing.&nbsp;</span>
                          }
                          @if (orderLists.membershipData.currentMembership == 'flu360 Pricing') {
                            <span>{{orderLists.membershipData.currentMembership}}.&nbsp;</span>
                          }
                          <span [innerHTML]="pendingMembershipContent.content"></span>
                        </p>
                      }
                      @if (!isModelnSuccess) {
                        <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_BoldTxt">{{activeMembershipContent.text1}}</strong></p>
                      }
                      @if (!isModelnSuccess) {
                        <p class="price_detail" [innerHTML]="activeMembershipContent.text2"></p>
                      }
                    </div>
                  }
                </div>
              }
              <!-- Mmbership content ends -->
              <!--Add Products list in the cart starts here -->
              @if (showSelectedProducts) {
                <div class="order-listing pl-0 pr-0">
                  @for (item1 of selectedProducts; track item1; let i = $index) {
                    <div>
                      <div class="product_according pl-0 pr-0 Activestage d-none d-sm-none d-md-none d-xl-block d-lg-block"
                        id="product-10052815">
                        <div class="col-md-12 product_row">
                          <div class="col-md-11 pl-0 pr-0 left-pro-list"
                            [ngClass]="item1.showAngleDownArrow ? '' : 'border_cart_select'">
                            <div class="col-md-2 pro_desc d-none d-sm-none d-md-block d-lg-block d-xl-block product_Accordion_Pro_Desc">
                              <img alt="{{item1.baseName}}"
                                [src]="'../../assets/images/'+item1.baseName+'.webp'" width="83%">
                              </div>
                              <div class="col-md-3 col-xs-10 pro_desc baseName_Pro_Desc">
                                {{item1.baseName}}
                              </div>
                              <!-- <div class="col-xs-2 pl-0 pr-0 del_section d-md-none d-lg-none d-none d-sm-none border_del_select"
                              style="align-content: center;">
                            </div> -->
                            <div class="col-md-3 pro_desc col-xs-8 presentationName_Pro_Desc">
                            {{item1.presentationName}}</div>
                            <div class="col-md-3 pro_desc pro_qty d-none d-sm-none d-md-block d-lg-block d-xl-block notvisible-ipad totalQty_Pro_Desc">
                              <strong>{{'startOrder.addproduct.totalqty' | cxTranslate}}<span
                                class="count_qty">{{selectedProducts[i].totalquantity |
                              number:'1.0'}}</span></strong>
                            </div>
                            <div class="col-md-2 col-xs-4 pro_desc pro_qty d-md-none d-lg-none d-block d-sm-block visible-ipad totalQty_Pro_Desc_Ipad">
                              <strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span class="count_qty">{{selectedProducts[i].totalquantity
                                |
                              number:'1.0'}}</span></strong>
                            </div>
                            <div class="qty_Right_Border">
                            </div>
                            <div class="col-md-1 pro_desc col-xs-12 d-none d-sm-none d-md-block d-lg-block accordion pro_Desc_Accordion"
                              [id]="'accordion'+i">
                              <i class="show_pro_details fa fa-angle-up"
                                (click)="handleOnToggle(item1,i)" aria-hidden="true"
                              [attr.data-bs-target]="'#part'+i"></i>
                            </div>
                          </div>
                          <div class="col-md-1 pl-0 pr-0 del_section border_del_select"
                            [ngStyle]="{'border': item1.showAngleDownArrow ? 'none' : ''}"><i
                            class="fa-regular fa-trash-can" aria-hidden="true"
                            data-button-id="addBtn-10052815"
                          (click)="handleOnDeleteBtnClick(item1,i)"></i></div>
                        </div>
                        <div class="accordion col-md-12 pro_calc_wrapper collapse show" [id]="'part'+i"
                          [attr.data-bs-parent]="'#accordion'+i">
                          <div class="row">
                            <div class="col-md-3 spcl_3">@if (item1.baseName=='Fluad') {
                              <a href="/FluadPrescribingInfoPDF" target="_blank"
                              class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                            }
                            @if (item1.baseName=='Flucelvax') {
                              <a href="/FlucelvaxPrescribingInfoPDF" target="_blank"
                              class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                            }
                            @if (item1.baseName=='Afluria') {
                              <a href="/AfluriaPrescribingInfoPDF" target="_blank"
                              class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                            }
                            <!-- <a *ngIf="item1.baseName=='Afluria'" href="/products/afluria" target="_blank"
                          class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a> -->
                        </div>
                        <div class="col-md-3">@if (item1.baseName=='Fluad') {
                          <a href="/products/fluad" target="_blank"
                          class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a>
                        }
                        @if (item1.baseName=='Flucelvax') {
                          <a href="/products/flucelvax" target="_blank"
                          class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a>
                        }
                      </div>
                      <div class="col-md-3">
                        <!--  <a *ngIf="item1.baseName=='Afluria'"
                        href="/flu-vaccine-resources/afluria-coding-billing" target="_blank"
                      class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a> -->
                      @if (item1.baseName=='Flucelvax') {
                        <a
                          href="/flu-vaccine-resources/flucelvax-coding-billing" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a>
                      }
                      @if (item1.baseName=='Fluad') {
                        <a
                          href="/flu-vaccine-resources/fluad-coding-billing" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a>
                      }
                    </div>
                    <div class="col-md-3 col-xs-12 cart_doses_link">
                      {{item1.priceData.value
                      | currency: item1.priceData.currency}}per
                      unit&nbsp;&nbsp;|&nbsp;&nbsp;{{item1.doses}} doses per unit
                    </div>
                  </div>
                  <!-- <input min="0" max="9999" placeholder="0" name="orderReviewdata[0].productCode" type="number" class="form-control qty-messure locqty" value="0" maxlength="4" > -->
                  @if (item1.location.length>0) {
                    <div>
                      @for (locationDetail of item1.location; track locationDetail; let index = $index) {
                        <div class="locationrowall col-md-12 product_calc locationrow0060151646 hide addedProducts_Col"
                          >
                          <div class="col-md-2">{{locationDetail.locname}} </div>
                          <div class="col-md-4 locationDetail_Adress">{{locationDetail.address}}
                          </div>
                          <div class="col-md-4 locationDetail_State">{{locationDetail.state}}
                          </div>
                          <div class="col-md-2 cart_inputUnit">
                            <input type="text" id="'locationDetail{{i}}{{index}}'" name="'locationDetail{{i}}{{index}}'" min="0" max="9999"  placeholder="0"
                              class="form-control qty-messure locqty0060151646 locqty" maxlength="4"
                              [(ngModel)]="item1.location[index].value"
                              (keyup)="handleOnUnitChange($event,i,index)" ><label
                              class="cart_unitLabel" for="locqty"><i>units</i></label>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="col-md-12 total_count locationrow ">
                      <div class="col-md-7 col-xs-6 no-padding-left total-order-txt">
                        <strong>{{'startOrder.addproduct.totalcost' | cxTranslate}}</strong>
                      </div>
                      <div class="col-md-2 col-xs-6 padding-R10 total_doses_item">
                        <strong><span class="total_doses">{{selectedProducts[i].totalDoses |
                        number:'1.0'}}</span>&nbsp;doses</strong>
                      </div>
                      <div class="col-md-3 col-xs-12  total_cost_item">
                        <strong>@if (selectedProducts[i].totalAmount) {
                          <span class="total_amnt"
                          >{{selectedProducts[i].totalAmount}}</span>
                          }@if (!(selectedProducts[i].totalAmount)) {
                          <span
                            class="total_amnt"
                            >{{'0.00' |
                          currency: item1.priceData.currency}}</span>
                        }</strong>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="product_according mobile_view pl-0 pr-0 d-block d-sm-block d-md-block d-lg-none d-xl-none mob_Product_Accordion">
                  <div class="col-md-12 pl-0 pr-0 left-pro-list">
                    <div class="pro_desc">
                      <div> {{item1.baseName}}</div>
                      <div class="l-0 pr-0 "><i class="fa-regular fa-trash-can" (click)="handleOnDeleteBtnClick(item1,i)"></i></div>
                    </div>
                    <div class="pro_desc ">
                      <div> {{item1.presentationName}}</div>
                      <div class="pro_desc pro_qty"><strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span
                        class="count_qty">{{selectedProducts[i].totalquantity |
                      number:'1.0' }}</span></strong>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pro_calc_wrapper collapse show" [id]="'part'+i"
                  [attr.data-bs-parent]="'#accordion'+i">
                  <div class="row">
                    <div class="col-xs-12 cart_doses_link">{{item1.priceData.value
                      | currency: item1.priceData.currency}}
                    unit&nbsp;&nbsp;|&nbsp;&nbsp;{{item1.doses}} doses per unit</div>
                  </div>
                  @if (item1.location.length>0) {
                    <div>
                      @for (locationDetail of item1.location; track locationDetail; let index = $index) {
                        <div class="locationrowall col-md-12 product_calc"
                          >
                          <div>{{locationDetail.locname}} </div>
                          <div>{{locationDetail.address}}</div>
                          <div>{{locationDetail.state}}</div>
                          <div class="col-md-12 cart_inputUnit pl-0 pr-0">
                            <input type="text" name="'locationDetail{{i}}{{index}}'" placeholder="0"  min="0" max="9999"
                              class="form-control qty-messure locqty0060151646 locqty" id="'locationDetail{{i}}{{index}}'" maxlength="4"
                              [(ngModel)]="item1.location[index].value"
                              (keyup)="handleOnUnitChange($event,i,index)"><label
                              class="cart_unitLabel" for="locqty"><i>units</i></label>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="col-md-12 total_count locationrow ">
                      <div class="col-md-10 col-xs-6 no-padding-left total-order-txt">
                        <strong>{{'startOrder.addproduct.totalcost' | cxTranslate}}</strong>
                      </div>
                      <div class="col-md-2 col-xs-6 no-padding-right total_doses_item">
                        <strong><span class="total_doses">{{selectedProducts[i].totalDoses |
                          number:'1.0' }}
                        doses</span></strong>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12 no-padding-right total_cost_item">
                      <strong>@if (selectedProducts[i].totalAmount) {
                        <span class="total_amnt"
                        >{{selectedProducts[i].totalAmount}}</span>
                        }@if (!(selectedProducts[i].totalAmount)) {
                        <span
                          class="total_amnt"
                          >{{'0.00' |
                        currency: item1.priceData.currency}}</span>
                      }</strong>
                    </div>
                    <div class=" mob-prescribe">
                      <div class="spcl_5 ">@if (item1.baseName=='Fluad') {
                        <a href="/FluadPrescribingInfoPDF" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                      }
                      @if (item1.baseName=='Flucelvax') {
                        <a href="/FlucelvaxPrescribingInfoPDF" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                      }
                      @if (item1.baseName=='Afluria') {
                        <a href="/AfluriaPrescribingInfoPDF" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</a>
                      }</div>
                      <div class="padding-T10">@if (item1.baseName=='Fluad') {
                        <a href="/products/fluad" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a>
                      }
                      @if (item1.baseName=='Flucelvax') {
                        <a href="/products/flucelvax" target="_blank"
                        class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a>
                      }
                      <!-- <a *ngIf="item1.baseName=='Afluria'" href="/products/afluria" target="_blank"
                    class="cart_pdf_link">{{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</a></div> -->
                    <!-- <div class="padding-T10"><a *ngIf="item1.baseName=='Afluria'"
                    href="/flu-vaccine-resources/afluria-coding-billing" target="_blank"
                  class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a> -->
                  @if (item1.baseName=='Flucelvax') {
                    <a
                      href="/flu-vaccine-resources/flucelvax-coding-billing" target="_blank"
                    class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a>
                  }
                  @if (item1.baseName=='Fluad') {
                    <a
                      href="/flu-vaccine-resources/fluad-coding-billing" target="_blank"
                    class="cart_pdf_link">{{'startOrder.addproduct.codingnbillguide' | cxTranslate}}</a>
                  }</div>
                </div>
              </div>
              <div class="pro_desc col-xs-12 notvisible-ipad mobile-according">
                <span><i class="fa show_pro_details fa-angle-up" aria-hidden="true"
                  (click)="handleOnToggle(item1,i)" aria-hidden="true"
                data-bs-toggle="collapse" [attr.data-bs-target]="'#part'+i"></i></span>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <!--Add Products list in the cart ends here -->
    <!--Product List starts -->
    <div class="col-xs-12 top-b"></div>
    <div class="col-xs-12 col-md-12 pr-0 pl-0 ">
      <div class="col-12 col-lg-12 col-xl-12 pl-0 pr-0 prod_mobView">
        <div class="col-12 col-lg-10 col-xl-10 pl-0 pr-0 mobaddproduct">
          <div class="add_product_btn add_product_btn12"  (click)="handleOnAddProductBtnClick()"
            [ngClass]="showProductList ? 'border-add' : ''">{{'startOrder.addproduct.title' | cxTranslate}} <i
            class="fa fa-plus" aria-hidden="true"
          ></i></div>
          @if (showProductList) {
            <div class="col-md-12 cart_list_wrap">
              @if (seasonValue === 'inSeason' && orderLists.inSeasonProducts.length > 0) {
                @for (item of orderLists.inSeasonProducts; track item; let i = $index) {
                  @if (item.productlistshow==true) {
                    <div class="col-md-12 prod_list active_stage add_pro_cart" data-button-id="'addproduct'+i"
                      (click)="item.sellable && handleOnAddClick(item, i)">
                      <div class="col-md-4 pl-0 pr-0 basename"
                        [ngStyle]="{'cursor': item.sellable ? 'pointer' : 'default'}">
                      {{item.baseName}}</div>
                      <div class="col-md-6 pl-0 pr-0"
                        [ngStyle]="{'cursor': item.sellable ? 'pointer' : 'default'}">
                      {{item.presentationName}}</div>
                      <div class="col-md-2 pl-0 pr-0"
                        [ngStyle]="{'cursor': item.sellable ? 'pointer' : 'default'}"
                        >
                        @if (item.sellable) {
                          <span>{{'startOrder.addproduct.addlabel' | cxTranslate}}&nbsp;&nbsp;<i class="fa fa-plus"
                          aria-hidden="true"></i></span>
                        }
                        @if (!item.sellable) {
                          <span class="sold_Out_Label">{{'startOrder.addproduct.soldoutlabel' | cxTranslate}}</span>
                        }
                      </div>
                    </div>
                  }
                }
              }
              @if (seasonValue === 'prebook' && orderLists.preBookProducts.length > 0) {
                @for (item of orderLists.preBookProducts; track item; let i = $index) {
                  @if (item.productlistshow==true) {
                    <div class="col-md-12 prod_list active_stage add_pro_cart"
                      [ngClass]="!item.sellable?'soldnotadd':''" (click)="item.sellable && handleOnAddClick(item, i)">
                      <div class="col-md-4 pl-0 pr-0 basename">{{item.baseName}}</div>
                      <div class="col-md-6 pl-0 pr-0">{{item.presentationName}}</div>
                      <div class="col-md-2 pl-0 pr-0"
                        [ngStyle]="{'cursor': item.sellable ? 'pointer' : 'default'}"
                        >
                        @if (item.sellable) {
                          <span>{{'startOrder.addproduct.addlabel' | cxTranslate}}&nbsp;&nbsp;<i class="fa fa-plus"
                          aria-hidden="true"></i></span>
                        }
                        @if (!item.sellable) {
                          <span class="pre_Sold_Out_Label">{{'startOrder.addproduct.soldoutlabel' | cxTranslate}}</span>
                        }
                      </div>
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
        <div class="col-6 col-lg-2 col-xl-2 mob_border pr-0 d-lg-block d-xl-block no-padding-left desktopbtn">
          <button class="btn-confirm rvw_btn_enable"
            (click)="handleOnPlaceOrderBtnClick();scrollToTop()"
            [disabled]="disablePlaceOrderBtn()">
          {{'startOrder.addproduct.reviewnplaceorder' | cxTranslate}}</button>
        </div>
      </div>
    </div>
    <!--Product List ends -->
  </div>
  <div class="col-6 mobreviewbtn col-xl-2 mob_border pr-0  no-padding-left">
    <button class="btn-confirm rvw_btn_enable"
      (click)="handleOnPlaceOrderBtnClick();scrollToTop()"
      [disabled]="disablePlaceOrderBtn()">
    {{'startOrder.addproduct.reviewnplaceorder' | cxTranslate}}</button>
  </div>
</div>
<div>
</div><!-- Add product DIV ends -->
</div>
</div>
}
<!-- Product page ends -->

<!-- Review page starts -->
@if (showLegacyReviewPage && showReviewContent && orderLists) {
  <div>
    <div class="cart_delete">
      <div class="global_blackarrow"></div><button data-bs-toggle="modal" data-bs-target="#cart_deletemodal"
      data-bs-backdrop="false"><span class="delete-container">{{'startOrder.review.deletecartlabel' | cxTranslate}}</span></button>
    </div>
    <section class="cart_selectlocations" id="cart_summaryLocation">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_memberbox mb-5 pl-0 pr-0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryContentbox reviewsectionpadding padding-T30">
          <div class="cart_summaryProductselection cart_Summary_Backtotop_Section">
            <div class="global_blackarrow"></div>
            <div (click)="handleOnBackToProductBtnClick();scrollToTop()">{{'startOrder.review.backtoprodtxt' | cxTranslate}}</div>
          </div>
          <!-- membership changes start's -->
          <div class="col-xs-12 memberline"></div>
          @if (orderLists && (orderLists.membershipData.membershipStatus == 'Active') && !showPendingMessage) {
            <div class="col-xs-12 pl-0 pr-0"
              >
              @if (activeMembershipContent) {
                <div class="productmemberdetails  reviewpagemembership">
                  <p>
                    {{activeMembershipContent.title}}
                    <strong>{{orderLists.membershipData.currentMembership}}.</strong>
                  </p>
                  <p>{{pendingMembershipContent.text2}}</p>
                  @if (!isModelnSuccess) {
                    <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Active">{{activeMembershipContent.text1}}</strong></p>
                  }
                  @if (isModelnSuccess) {
                    <div [innerHTML]="activeMembershipContent.content"></div>
                  }
                  @if (!isModelnSuccess) {
                    <div class="price_detail" [innerHTML]="activeMembershipContent.text2"></div>
                  }
                </div>
              }
            </div>
          }
          @if (orderLists && orderLists.membershipData.membershipStatus == 'Pending' || showPendingMessage) {
            <div class="col-xs-12 no-padding"
              >
              @if (pendingMembershipContent) {
                <div class="col-xs-12 productmemberdetails reviewpagemembership">
                  <p>{{pendingMembershipContent.title}}</p>
                  <p>{{pendingMembershipContent.text2}}</p>
                  @if (isModelnSuccess) {
                    <p>
                      Prices shown reflect current
                      @if (orderLists.membershipData.currentMembership != 'flu360 Pricing') {
                        <span>{{orderLists.membershipData.currentMembership}} pricing.&nbsp;</span>
                      }
                      @if (orderLists.membershipData.currentMembership == 'flu360 Pricing') {
                        <span>{{orderLists.membershipData.currentMembership}}.&nbsp;</span>
                      }
                      <span [innerHTML]="pendingMembershipContent.content"></span>
                    </p>
                  }
                  @if (!isModelnSuccess) {
                    <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Pending">{{activeMembershipContent.text1}}</strong></p>
                  }
                  @if (!isModelnSuccess) {
                    <p class="price_detail" [innerHTML]="activeMembershipContent.text2"></p>
                  }
                </div>
              }
            </div>
          }
          <!-- membership changes end's -->
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summarytable no-padding"
            id="cart_summaryProductTable">
            <table class="cart_Summary_Prod_Table">
              <thead>
                <tr>
                  @for (item of cartListData.products; track item) {
                    <th><br>{{item.product}}<br><br><span>{{item.dose}}</span></th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (locations of cartListData.locations; track locations) {
                  <tr>
                    <td>
                      {{locations.location}}
                    </td>
                    @for (productCount of locations.locationProducts; track productCount) {
                      <td>{{productCount.locQty | number:'1.0'}}</td>
                    }
                  </tr>
                }
                <tr class="cartlist_Prod_Qty">
                  @for (productQty of cartListData.productstotalQty; track productQty) {
                    <td>
                      {{productQty.qty}}
                    </td>
                  }
                </tr>
                <tr>
                  @for (productCost of cartListData.productstotalCost; track productCost) {
                    <td>{{productCost.cost}} </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
          @if (cartListData) {
            <div class="product_according review_mobile_view pl-0 pr-0 d-block d-sm-block d-md-block d-lg-none d-xl-none"
              >
              @for (item1 of cartListData.data; track item1; let i = $index) {
                <div class="col-md-12 pl-0 pr-0 left-pro-list">
                  <div class="pro_desc">
                    <div> {{item1.productname}}</div>
                  </div>
                  <div class="pro_desc ">
                    <div> {{item1.dose}}</div>
                  </div>
                  <div class="pro_desc pro_qty"><strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span
                  class="count_qty">{{item1.totalquantity | number:'1.0'}}</span></strong>
                </div>
              </div>
              <div class="col-md-12 pro_calc_wrapper collapse show" [id]="'part1'+i"
                [attr.data-bs-parent]="'#accordion1'+i">
                <div class="row">
                  <div class="col-md-12 total_count locationrow ">
                    <div class="col-md-10 col-xs-6 no-padding-left total-order-txt">
                      <strong>{{'startOrder.addproduct.totalcost' | cxTranslate}}</strong>
                    </div>
                    <div class="col-md-12 col-xs-12 no-padding-right total_cost_item">
                      <strong><span class="total_amnt">${{item1.totalcost | number:'1.0'}}</span></strong>
                    </div>
                  </div>
                </div>
                @if (item1.locations.length>0) {
                  <div class="reviewlocation">
                    @for (locationDetail of item1.locations; track locationDetail; let index = $index) {
                      <div class="locationrowall col-md-12 product_calc">
                        <div>{{locationDetail.locname}} </div>
                        <div>{{locationDetail.locstreet}}</div>
                        <div>{{locationDetail.state}}</div>
                        <div class="col-md-12 cart_inputUnit pl-0 pr-0 cart_Input_Qty">
                          <strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span
                          class="count_qty">{{locationDetail.locqtn}}</span></strong>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="pro_desc col-xs-12 notvisible-ipad mobile-according" accordion
                [id]="'accordion1'+i">
                <span><i class="fa show_pro_details fa-angle-up" aria-hidden="true"
                  (click)="handleOnToggle1(item1,i)" aria-hidden="true" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#part1'+i"></i></span>
              </div>
            }
          </div>
        }
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryborder"></div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryContentbox  no-padding">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling billingreviewpadding pr-0">
          <div class="cart_summarybillingHeader">{{'startOrder.review.billloc' | cxTranslate}}</div>
          <div class="cart_summarybillingaddressline" id="cart_summarybillingaddressline1">
          {{cartListData.billing.addressline1}}</div>
          <div class="cart_summarybillingaddressline" id="cart_summarybillingaddressline2">
          {{cartListData.billing.addressline2}}</div>
          <div class="cart_summarybillingtext">{{'startOrder.review.billlocmsg' | cxTranslate}}</div>
          <a class="cart_summaryupdatebilling" routerLink="/organization-location"
            target="_blank">{{'startOrder.review.updatebillloc' | cxTranslate}}<div class="global_blackarrow"></div>
          </a>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer payerrightpadding">
          <div class="cart_summarypayerHeader">{{'startOrder.review.payerloc' | cxTranslate}}</div>
          <div class="cart_summarypayeraddressline" id="cart_summarypayeraddressline1">
          {{cartListData.paying.addressline1}}</div>
          <div class="cart_summarypayeraddressline" id="cart_summarypayeraddressline2">
          {{cartListData.paying.addressline2}}</div>
          <div class="cart_summarypayertext">{{'startOrder.review.payerlocmsg' | cxTranslate}}
          </div>
          <a class="cart_summaryupdatepayer" routerLink="/organization-location"
            target="_blank">{{'startOrder.review.updatepayerloc' | cxTranslate}}<div class="global_blackarrow"></div>
          </a>
        </div>
        <div class="clearboth"></div>
        <div class="col-xs-12 cart_summaryPOsection pl-0">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling billingreviewpadding">
            <div class="cart_summaryPO">{{'startOrder.review.enterpo' | cxTranslate}}</div>
            <div class="cart_summaryPOlabel">{{'startOrder.review.ponumlabel' | cxTranslate}}</div>
            <div class="cart_summaryPOinput">
              <input #poNumberField type="text" id="poRefNumber" class="cart_summaryPOinputbox"
                maxlength="10" [(ngModel)]="poNumber" #autogenerateNo="ngModel">
                <div class="cart_summaryPOautogenerate" (click)="handleOnAutoGeneratePoNo()">
                {{'startOrder.review.autogenratepo' | cxTranslate}}</div>
              </div>
              @if ((autogenerateNo.dirty && autogenerateNo.value == '') || (showErrorMsg && !poNumber)) {
                <div class="cart_summaryPO-error cart_summary-error"
                  >
                {{'startOrder.review.poerrormsg' | cxTranslate}}</div>
              }
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer no-padding-right">
              <div class="cart_summaryorderTotal">{{'startOrder.review.ordertotal' | cxTranslate}}</div>
              <div class="cart_summarysubTotal">
                <div class="cart_summarysubTotallabel cart_summaryLabel">{{'startOrder.review.subtotal' | cxTranslate}}</div>
                <div class="cart_summarysubTotalno cart_summarySum">{{cartListData.cost.subtotal}}
                </div>
              </div>
              <div class="cart_summaryexcise">
                <div class="cart_summaryexciselabel cart_summaryLabel">{{'startOrder.review.federaltax' | cxTranslate}}</div>
                <div class="cart_summaryexciseno cart_summarySum">{{cartListData.cost.federalTax}}
                </div>
              </div>
              <div class="cart_summarytotal">
                <div class="cart_summarytotallabel cart_summaryLabel">{{'startOrder.addproduct.totalcost' | cxTranslate}}</div>
                <div class="cart_summarytotalno cart_summarySum">{{cartListData.cost.totalCost}}
                </div>
              </div>
            </div>
          </div>
          <div class="clearboth"></div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling  billingreviewpadding pr-0">
            <div class="cart_summaryshipping">{{'startOrder.review.shiptimeframe' | cxTranslate}}</div>
            <div class="cart_summaryshippingtext" [innerHTML]="'startOrder.review.shiptimeinfo' | cxTranslate"></div>
            <div class="cart_summaryshippingtext margin-B30" [innerHTML]="'startOrder.review.shipinfomsg' | cxTranslate"></div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer summarypayer payerrightpadding"
            id="summarypayer1">
            @if (seasonValue === 'inSeason') {
              <div class="cart_summaryexpected">
                <!--  Expected Shipping for
                <span>2024-2025</span> -->
                {{shipInfoInseasonContent?.title}}
              </div>
            }
            @if (seasonValue === 'inSeason') {
              <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoInseasonContent?.content">
                <!-- Shipping for the
                2024-2025 season is expected to
                begin July 2024. Deliveries are prioritized based on when they were ordered. Please
                refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                most recent shipping information and shipping dates. -->
              </div>
            }
            @if (seasonValue === 'prebook') {
              <div class="cart_summaryexpected">
                <!-- Expected Shipping for
                <span>2025-2026</span> -->
                {{shipInfoPreseasonContent?.title}}
              </div>
            }
            @if (seasonValue === 'prebook') {
              <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoPreseasonContent?.content">
                <!--  Shipping for the
                2025-2026 season is expected to
                begin July 2025. Deliveries are prioritized based on when they were ordered. Please
                refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
              most recent shipping information and shipping dates. --></div>
            }
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer summarypayer no-padding-right"
            id="summarypayer2">
            @if (seasonValue === 'inSeason') {
              <div class="cart_summaryexpected">
                <!-- Expected Shipping for
                <span>2024-2025</span> -->
                {{shipInfoInseasonContent?.title}}
              </div>
            }
            @if (seasonValue === 'inSeason') {
              <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoInseasonContent?.content">
                <!-- Shipping for the
                2024-2025 season is expected to
                begin July 2024. Deliveries are prioritized based on when they were ordered. Please
                refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                most recent shipping information and shipping dates. -->
              </div>
            }
            @if (seasonValue === 'prebook') {
              <div class="cart_summaryexpected">
                <!-- Expected Shipping for
                <span>2025-2026</span> -->
                {{shipInfoPreseasonContent?.title}}
              </div>
            }
            @if (seasonValue === 'prebook') {
              <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoPreseasonContent?.content">
                <!-- Shipping for the
                2025-2026 season is expected to
                begin July 2025. Deliveries are prioritized based on when they were ordered. Please
                refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                most recent shipping information and shipping dates. -->
              </div>
            }
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryborder"></div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryContentbox reviewsectionpadding">
          <div class="col-xs-12 no-padding-left no-margin-top cart_summaryexpected">{{'startOrder.review.termsnconditions' | cxTranslate}}</div>
          <div class="col-xs-12 cart_summarybilling no-padding-left">
            <div class="pdf-container">
              <iframe class="pdf desktoppdf hidden-xs hidden-sm" id="pdf-iframe1" [src]="cleanURL()"
              width="100%" frameborder="0" scrolling="no"></iframe>
              <div class="cart_summarycheckbox">
                <label class="checkbox-button">
                  <input type="checkbox" class="cartSummary_checkbox" [(ngModel)]="termsCheckbox"
                    #checkbox="ngModel" #termsCheckboxField>
                    <span class="checkbox-button__control"></span>
                  </label>
                  <div id="summarycheckpayer2">
                    <label>{{'startOrder.review.tncagreemsg' | cxTranslate}}
                      <a [href]="iframeUrl" target="_blank">{{'startOrder.review.termsnconditions' | cxTranslate}}</a></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 cart_summarypayer margin-B30 cart_summarypayer  mobsubmitbtn no-padding-right">
                @if ((checkbox.dirty && checkbox.value == false) || (showErrorMsg && !termsCheckbox)) {
                  <div class="cart_summarycheckbox-error cart_summary-error 0"
                    >
                  {{'startOrder.review.termsnconditionserror' | cxTranslate}}</div>
                }
                <button class="cart_summaryPlaceorder active" (click)="focusOnInputField()">{{'startOrder.review.placeorderlabel' | cxTranslate}}</button>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
        </section>
      </div>
    }
    <!-- Review page ends -->

    <!--Shipment Flexibility Review page starts-->
    @if (showReviewContent && orderLists) {
      <div>
        <div class="cart_delete">
          <div class="global_blackarrow"></div><button data-bs-toggle="modal" data-bs-target="#cart_deletemodal"
          data-bs-backdrop="false"><span class="delete-container">{{'startOrder.review.deletecartlabel' | cxTranslate}}</span></button>
        </div>
        <div class="shipFlex_mob_topline d-none"></div>
        <section class="shipFlex_cart_selectlocations" id="shipFlex_cart_summaryLocation">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_memberbox mb-5 pl-0 pr-0">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryContentbox shipFlex_reviewsectionpadding padding-T30">
              <div class="cart_summaryProductselection cart_Summary_Backtotop_Section">
                <div class="global_blackarrow"></div>
                <div (click)="handleOnBackToShipFlexBtnClick();scrollToTop()">{{'startOrder.review.backtoprodtxt' | cxTranslate}}</div>
              </div>
              <!-- membership changes start's -->
              <div class=" memberline"></div>
              @if (orderLists && (orderLists.membershipData.membershipStatus == 'Active') && !showPendingMessage) {
                <div class="col-xs-12 pl-0 pr-0"
                  >
                  @if (activeMembershipContent) {
                    <div class="productmemberdetails  reviewpagemembership">
                      <p>
                        {{activeMembershipContent.title}}
                        <strong>{{orderLists.membershipData.currentMembership}}.</strong>
                      </p>
                      <p>{{pendingMembershipContent.text2}}</p>
                      @if (!isModelnSuccess) {
                        <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Active">{{activeMembershipContent.text1}}</strong></p>
                      }
                      @if (isModelnSuccess) {
                        <div [innerHTML]="activeMembershipContent.content"></div>
                      }
                      @if (!isModelnSuccess) {
                        <div class="price_detail" [innerHTML]="activeMembershipContent.text2"></div>
                      }
                    </div>
                  }
                </div>
              }
              @if (orderLists && orderLists.membershipData.membershipStatus == 'Pending' || showPendingMessage) {
                <div class="col-xs-12 no-padding"
                  >
                  @if (pendingMembershipContent) {
                    <div class="col-xs-12 productmemberdetails reviewpagemembership">
                      <p>{{pendingMembershipContent.title}}</p>
                      <p>{{pendingMembershipContent.text2}}</p>
                      @if (isModelnSuccess) {
                        <p>
                          Prices shown reflect current
                          @if (orderLists.membershipData.currentMembership != 'flu360 Pricing') {
                            <span>{{orderLists.membershipData.currentMembership}} pricing.&nbsp;</span>
                          }
                          @if (orderLists.membershipData.currentMembership == 'flu360 Pricing') {
                            <span>{{orderLists.membershipData.currentMembership}}.&nbsp;</span>
                          }
                          <span [innerHTML]="pendingMembershipContent.content"></span>
                        </p>
                      }
                      @if (!isModelnSuccess) {
                        <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Pending">{{activeMembershipContent.text1}}</strong></p>
                      }
                      @if (!isModelnSuccess) {
                        <p class="price_detail" [innerHTML]="activeMembershipContent.text2"></p>
                      }
                    </div>
                  }
                </div>
              }
              <!-- membership changes end's -->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summarytable no-padding"
                id="shipFlex_cart_summaryProductTable">
                <table class="cart_Summary_Prod_Table">
                  <thead>
                    <tr>
                      @for (item of cartListData.products; track item) {
                        <th>{{item.product}}<span>{{item.dose}}</span></th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (locations of cartListData.locations; track locations; let locIndex = $index) {
                      <tr>
                        <td>
                          {{locations.location}}@if (confirmedDate && (seasonValue === 'inSeason' && ONSNEnabled)) {
                          <span class="shipFlex_estimateDate"  >Estimated delivery: <input class="date-box"  type="text" [value]="(selectedProducts?.[0]?.location?.[getReviewLocationIndex(locations.shipToId)]?.deliveryDate || confirmedDate) | date: 'MMMM d, y'" readonly /> </span>
                        }
                      </td>
                      @for (productCount of locations.locationProducts; track productCount) {
                        <td>{{productCount.locQty | number:'1.0'}}</td>
                      }
                    </tr>
                  }
                  <tr class="cartlist_Prod_Qty">
                    @for (productQty of cartListData.productstotalQty; track productQty) {
                      <td>
                        {{productQty.qty}}
                      </td>
                    }
                  </tr>
                  <tr>
                    @for (productCost of cartListData.productstotalCost; track productCost) {
                      <td>{{productCost.cost}} </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            @if (cartListData) {
              <div class="product_according shipFlex_review_mobile_view pl-0 pr-0 d-block d-sm-block d-md-block d-lg-none d-xl-none"
                >
                @for (item1 of cartListData.data; track item1; let i = $index) {
                  <div class="col-md-12 pl-0 pr-0 left-pro-list">
                    <div class="pro_desc">
                      <div> {{item1.productname}}</div>
                    </div>
                    <div class="pro_desc ">
                      <div> {{item1.dose}}</div>
                    </div>
                    <div class="pro_desc pro_qty"><strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span
                    class="count_qty">{{item1.totalquantity | number:'1.0'}}</span></strong>
                  </div>
                </div>
                <div class="col-md-12 pro_calc_wrapper collapse show" [id]="'part1'+i"
                  [attr.data-bs-parent]="'#accordion1'+i">
                  <div class="row">
                    <div class="col-md-12 total_count locationrow ">
                      <div class="col-md-10 col-xs-6 no-padding-left total-order-txt">
                        <strong>{{'startOrder.addproduct.totalcost' | cxTranslate}}</strong>
                      </div>
                      <div class="col-md-12 col-xs-12 no-padding-right total_cost_item">
                        <strong><span class="total_amnt">${{item1.totalcost | number:'1.0'}}</span></strong>
                      </div>
                    </div>
                  </div>
                  @if (item1.locations.length>0) {
                    <div class="reviewlocation">
                      @for (locationDetail of item1.locations; track locationDetail; let index = $index) {
                        <div class="locationrowall col-md-12 product_calc">
                          <div>{{locationDetail.locname}} </div>
                          <div>{{locationDetail.locstreet}}</div>
                          <div>{{locationDetail.state}}</div>
                          @if (confirmedDate && (seasonValue === 'inSeason' && ONSNEnabled)) {
                            <span class="shipFlex_estimateDate"  >Estimated delivery: <input class="date-box"  type="text" [value]="(selectedProducts?.[0]?.location?.[getReviewLocationIndex(locationDetail.locID)]?.deliveryDate || confirmedDate)| date: 'MMMM d, y'" readonly /> </span>
                          }
                          <div class="col-md-12 cart_inputUnit pl-0 pr-0 cart_Input_Qty">
                            <strong>{{'startOrder.addproduct.qty' | cxTranslate}}<span
                            class="count_qty">{{locationDetail.locqtn}}</span></strong>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="pro_desc col-xs-12 notvisible-ipad mobile-according shipFlex_pro_desc" accordion
                  [id]="'accordion1'+i">
                  <span><i class="fa show_pro_details fa-angle-up" aria-hidden="true"
                    (click)="handleOnToggle1(item1,i)" aria-hidden="true" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#part1'+i"></i></span>
                </div>
              }
              <div class="shipFlex_cartlist_Prod_Qty">
                <span class="shipFlex_cartlist_Prod_Qty_name">Total Unit Quantity</span>
                <span class="shipFlex_cartlist_Prod_Qty_number">{{ getTotalMobileQty() | number:'1.0' }}</span>
              </div>
              <div class="shipFlex_cartlist_Prod_totalcost">
                <span class="shipFlex_cartlist_Prod_total_name">Total Cost</span>
                <span class="shipFlex_cartlist_Prod_total_number">{{ cartListData.cost.subtotal}}</span>
              </div>
            </div>
          }
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryborder"></div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 shipFlex_cart_summaryContentbox  no-padding">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling billingreviewpadding pr-0">
            <div class="cart_summarybillingHeader">{{'startOrder.review.billloc' | cxTranslate}}</div>
            <div class="cart_summarybillingaddressline" id="shipFlex_cart_summarybillingaddressline1">
            {{cartListData.billing.addressline1}}</div>
            <div class="cart_summarybillingaddressline" id="ShipFlex_cart_summarybillingaddressline2">
            {{cartListData.billing.addressline2}}</div>
            <div class="cart_summarybillingtext shipFlex_cart_summarybillingtext">{{'startOrder.review.billlocmsg' | cxTranslate}}</div>
            <a class="cart_summaryupdatebilling" routerLink="/organization-location"
              target="_blank">{{'startOrder.review.updatebillloc' | cxTranslate}}<div class="global_blackarrow"></div>
            </a>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer payerrightpadding">
            <div class="cart_summarypayerHeader">{{'startOrder.review.payerloc' | cxTranslate}}</div>
            <div class="cart_summarypayeraddressline" id="shipFlex_cart_summarypayeraddressline1">
            {{cartListData.paying.addressline1}}</div>
            <div class="cart_summarypayeraddressline" id="shipFlex_cart_summarypayeraddressline2">
            {{cartListData.paying.addressline2}}</div>
            <div class="cart_summarypayertext">{{'startOrder.review.payerlocmsg' | cxTranslate}}
            </div>
            <a class="cart_summaryupdatepayer" routerLink="/organization-location"
              target="_blank">{{'startOrder.review.updatepayerloc' | cxTranslate}}<div class="global_blackarrow"></div>
            </a>
          </div>
          <div class="clearboth"></div>
          <div class="col-xs-12 cart_summaryPOsection pl-0">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling billingreviewpadding">
              <div class="cart_summaryPO">{{'startOrder.review.enterpo' | cxTranslate}}</div>
              <div class="cart_summaryPOlabel">{{'startOrder.review.ponumlabel' | cxTranslate}}</div>
              <div class="cart_summaryPOinput">
                <input #poNumberField type="text" id="poRefNumber" class="cart_summaryPOinputbox"
                  maxlength="10" [(ngModel)]="poNumber" #autogenerateNo="ngModel">
                  <div class="cart_summaryPOautogenerate" (click)="handleOnAutoGeneratePoNo()">
                  {{'startOrder.review.autogenratepo' | cxTranslate}}</div>
                </div>
                @if ((autogenerateNo.dirty && autogenerateNo.value == '') || (showErrorMsg && !poNumber)) {
                  <div class="cart_summaryPO-error cart_summary-error"
                    >
                  {{'startOrder.review.poerrormsg' | cxTranslate}}</div>
                }
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer no-padding-right">
                <div class="cart_summaryorderTotal">{{'startOrder.review.ordertotal' | cxTranslate}}</div>
                <div class="cart_summarysubTotal">
                  <div class="cart_summarysubTotallabel cart_summaryLabel">{{'startOrder.review.subtotal' | cxTranslate}}</div>
                  <div class="cart_summarysubTotalno cart_summarySum">{{cartListData.cost.subtotal}}
                  </div>
                </div>
                <div class="cart_summaryexcise">
                  <div class="cart_summaryexciselabel cart_summaryLabel">{{'startOrder.review.federaltax' | cxTranslate}}</div>
                  <div class="cart_summaryexciseno cart_summarySum">{{cartListData.cost.federalTax}}
                  </div>
                </div>
                <div class="cart_summarytotal">
                  <div class="cart_summarytotallabel cart_summaryLabel">{{'startOrder.addproduct.totalcost' | cxTranslate}}</div>
                  <div class="cart_summarytotalno cart_summarySum">{{cartListData.cost.totalCost}}
                  </div>
                </div>
              </div>
            </div>
            <div class="clearboth"></div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarybilling  billingreviewpadding pr-0">
              <div class="cart_summaryshipping">{{'startOrder.review.shiptimeframe' | cxTranslate}}</div>
              <div class="cart_summaryshippingtext shipFlex_cart_summaryshippingtext" [innerHTML]="'startOrder.review.shiptimeinfo' | cxTranslate"></div>
              <div class="cart_summaryshippingtext margin-B30" [innerHTML]="'startOrder.review.shipinfomsg' | cxTranslate"></div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer summarypayer payerrightpadding"
              id="summarypayer1">
              @if (seasonValue === 'inSeason') {
                <div class="cart_summaryexpected">
                  <!--  Expected Shipping for
                  <span>2024-2025</span> -->
                  {{shipInfoInseasonContent?.title}}
                </div>
              }
              @if (seasonValue === 'inSeason') {
                <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoInseasonContent?.content">
                  <!-- Shipping for the
                  2024-2025 season is expected to
                  begin July 2024. Deliveries are prioritized based on when they were ordered. Please
                  refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                  most recent shipping information and shipping dates. -->
                </div>
              }
              @if (seasonValue === 'prebook') {
                <div class="cart_summaryexpected">
                  <!-- Expected Shipping for
                  <span>2025-2026</span> -->
                  {{shipInfoPreseasonContent?.title}}
                </div>
              }
              @if (seasonValue === 'prebook') {
                <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoPreseasonContent?.content">
                  <!--  Shipping for the
                  2025-2026 season is expected to
                  begin July 2025. Deliveries are prioritized based on when they were ordered. Please
                  refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                most recent shipping information and shipping dates. --></div>
              }
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 cart_summarypayer summarypayer no-padding-right"
              id="summarypayer2">
              @if (seasonValue === 'inSeason') {
                <div class="cart_summaryexpected">
                  <!-- Expected Shipping for
                  <span>2024-2025</span> -->
                  {{shipInfoInseasonContent?.title}}
                </div>
              }
              @if (seasonValue === 'inSeason') {
                <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoInseasonContent?.content">
                  <!-- Shipping for the
                  2024-2025 season is expected to
                  begin July 2024. Deliveries are prioritized based on when they were ordered. Please
                  refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                  most recent shipping information and shipping dates. -->
                </div>
              }
              @if (seasonValue === 'prebook') {
                <div class="cart_summaryexpected">
                  <!-- Expected Shipping for
                  <span>2025-2026</span> -->
                  {{shipInfoPreseasonContent?.title}}
                </div>
              }
              @if (seasonValue === 'prebook') {
                <div class="cart_summaryexpectedtext" [innerHTML]="shipInfoPreseasonContent?.content">
                  <!-- Shipping for the
                  2025-2026 season is expected to
                  begin July 2025. Deliveries are prioritized based on when they were ordered. Please
                  refer to your <a href="/orders/my-orders" target="_blank">Orders</a> page for the
                  most recent shipping information and shipping dates. -->
                </div>
              }
            </div>
            <div class="clearboth"></div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryborder"></div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_summaryContentbox reviewsectionpadding">
            <div class="col-xs-12 no-padding-left no-margin-top cart_summaryexpected">{{'startOrder.review.termsnconditions' | cxTranslate}}</div>
            <div class="col-xs-12 cart_summarybilling no-padding-left">
              <div class="pdf-container">
                <iframe class="pdf desktoppdf hidden-xs hidden-sm" id="shipFlex_pdf-iframe1" [src]="cleanURL()"
                width="100%" frameborder="0" scrolling="no"></iframe>
                <div class="cart_summarycheckbox">
                  <label class="checkbox-button">
                    <input type="checkbox" class="cartSummary_checkbox" [(ngModel)]="termsCheckbox"
                      #checkbox="ngModel" #termsCheckboxField>
                      <span class="checkbox-button__control"></span>
                    </label>
                    <div id="summarycheckpayer2">
                      <label>{{'startOrder.review.tncagreemsg' | cxTranslate}}
                        <a [href]="iframeUrl" target="_blank">{{'startOrder.review.termsnconditions' | cxTranslate}}</a></label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 cart_summarypayer margin-B30 cart_summarypayer  mobsubmitbtn no-padding-right">
                  @if ((checkbox.dirty && checkbox.value == false) || (showErrorMsg && !termsCheckbox)) {
                    <div class="cart_summarycheckbox-error cart_summary-error 0"
                      >
                    {{'startOrder.review.termsnconditionserror' | cxTranslate}}</div>
                  }
                  <button class="cart_summaryPlaceorder active" (click)="focusOnInputField()">{{'startOrder.review.placeorderlabel' | cxTranslate}}</button>
                </div>
                <div class="clearboth"></div>
              </div>
            </div>
          </section>
        </div>
      }
      <!-- Shipment Flexibility Review page End -->

      <!-- Thankyou page starts -->
      @if (showThankYouContent && (thankYouPageData | async); as thankYouData) {
        <div class="cart_ThankYou_Container">
          <section class="col-xs-11 col-md-11 cart_thankyousection"
            data-gtm-vis-recent-on-screen55327271_15="2134467" data-gtm-vis-first-on-screen55327271_15="2134467"
            data-gtm-vis-total-visible-time55327271_15="100" data-gtm-vis-has-fired55327271_15="1">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_thankyou no-padding">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_thankyouContentbox ">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_thankyouheadersection">
                  <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 cart_Thankyouheader">{{thankYouData.h5content}}</div>
                  <a routerLink="/orders/my-orders" class="col-lg-2 col-md-2 cart_viewOrderlink">{{'startOrder.viewOrderLabel' | cxTranslate}}</a>
                </div>
                <div class="order_thankyouline"></div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cart_Thankyoutext" [innerHTML]="thankYouData.largeparagraphcontent"></div>
                @if (checkPrePaymentCustomer()) {
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 prePayment_disclaimer" id="prePaymentDisclaimer">
                    <div class="prePayment_disclaimer_txt" [innerHTML]="thankYouData.prePaymentOrderConfirmationMessage"></div>
                    <div class="prePayment_disclaimer_txt1" [innerHTML]="thankYouData.prePaymentOrderCancellationNotice"></div>
                  </div>
                }
                <div class="order_thankyouline"></div>
                <div class="clearboth"></div>
              </div>
              <!-- //auto rollover enrolled -->
              @if(arrStatus == 'Enrolled'){
                <div class="arr_enrolledsection">
                  <div class="enrolled_headersection">
                    <div class="enrolled_imgsection">
                      <div class="enroll_tickicon"><img src="/assets/images/tick_icon.svg"></div>
                    </div>
                    <div [innerHTML]="thankYouData.h2content">
                    </div>
                  </div>
                  <div class="arr_EnrolledMsgSection">
                    <span class="arr_enrolledmsg" [innerHTML]="thankYouData.paragraphcontent"></span>
                  </div>
                </div>
              }
              <!-- auto rollover notenrolled -->
              @else{
              <div class="arrnotenroll_header">
                <div class="notenroll_imgsection">
                  <div class="enrollicon_img"><img src="/assets/images/enroll_icon.svg"></div>
                </div>
                <div class="enroll_title">{{thankYouData.h3content}}</div>
              </div>
              <div class="arrenroll_msg">{{thankYouData.content}}</div>
              <div class="enrolllink_section">
                <button class="global_greybtn order_enroll_btn" [routerLink]="thankYouData.h4content">{{'startOrder.enrollNowLabel' | cxTranslate}}</button>
                <span [innerHTML]="thankYouData.urlLink"></span>
              </div>
            }
          </div>
        </section>
      </div>
    }
    <!-- Thankyou page ends -->

    <!-- Bulk order page starts -->
    @if (showBulkOrderSection) {
      <section class="col-xs-12 col-md-11 cart_selectlocation collapse mt-3 bulkOrder_Cart_Select" id="cart_selectlocation-3"
        >
        <div class="cart_bulkOrder-desktop d-none d-sm-none d-md-none d-lg-block d-xl-block">
          <div class="col-xs-10 cart_bulkOrder-header">{{'startOrder.bulkorder.title' | cxTranslate}}</div>
          <div class="clearfix"></div>
          <hr>
            <div class="cart_bulkOrder-container">
              <div class="cart_bulkOrder-instruction">
                {{'startOrder.bulkorder.msg1' | cxTranslate}}
                <ol [innerHTML]="'startOrder.bulkorder.info1' | cxTranslate">
                </ol>
                <div class="cart_bulkOrder-info">{{'startOrder.bulkorder.msg2' | cxTranslate}}<a href="mailto:customerservice.us@seqirus.com"
                [innerHTML]="'customerservice.us@seqirus.com'"></a>
              {{'startOrder.bulkorder.msg3' | cxTranslate}}</div>
            </div>
            <div class="cart_bulkOrder-download">
              <div class="cart_bulkOrder-downloadText">{{'startOrder.bulkorder.info2' | cxTranslate}}</div>
              @if (orderLists.inSeasonEnable) {
                <div class="cart_bulkOrder-InSeason cart_bulkOrder-season"
                (click)="handleOnBulkOrderSeasonBtnClick('inseason')">{{orderLists.inSeasonYear?.replace('-',' - ')}} Season Spreadsheet</div>
              }
              @if (orderLists.preSeasonEnable) {
                <div class="cart_bulkOrder-PreSeason cart_bulkOrder-season"
                (click)="handleOnBulkOrderSeasonBtnClick('preseason')">{{orderLists.preSeasonYear?.replace('-',' - ')}} Season Spreadsheet</div>
              }
            </div>
          </div>
          <div class="clearfix"></div>
          @if (orderSubmitContent == '' || orderSubmitContent != 'success') {
            <div class="col-xs-12 cart_bulkOrder-UploadContainer"
              >
              @if (!isUploading) {
                <div class="drop-area col-xs-12 " id="drop-area-excel">
                  <div class="drag-form" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)">
                    <div class="dragiconsection">
                      <img src="../../assets/images/cloud-upload.svg">
                      <p class="d-none d-md-block d-lg-block">{{'startOrder.bulkorder.dragndroptxt' | cxTranslate}}</p>
                    </div>
                    <p class="d-none d-md-block d-lg-block">or</p>
                    <input type="file" class="fileElemInp" id="fileElem-excel" [(ngModel)]="bulkOrderExcel"
                      (change)="onFileChange($event)"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                      <label class="button" for="fileElem-excel">{{'startOrder.bulkorder.browsetxt' | cxTranslate}}</label>
                    </div>
                    <div>
                    </div>
                  </div>
                }
                <div class="col-xs-9 uploading " id="uploadingscreen">
                  @if (isUploading && uploadData == '') {
                    <div class="filecont">
                      <div class="uplaodingfilenameparent">
                        <i class="fa fa-file-text"></i>
                        <div class="upload-container">
                          @if (bulkOrderExcel) {
                            <div class="uplaodingfilename floatLeft">
                            {{bulkOrderExcel.name}}</div>
                          }
                          <div class="uploadinglabel floatLeft ">{{'startOrder.bulkorder.tryagain' | cxTranslate}}</div>
                          <div class="clearfix"></div>
                          <div id="progressContainer" [style.width]="'100%'">
                            <div class="progress" id="progressBar" [style.width]="progressValue + '%'">
                            </div>
                          </div>
                          <div class="uploadFile-size hidden"></div>
                        </div>
                        <div class="uploadingcancel" (click)="removeFile()"> <span
                        class="glyphicon glyphicon-remove-circle"></span></div>
                      </div>
                    </div>
                  }
                </div>
                <!-- error section for format and file size -->
                <div class="col-xs-9 errorformat">
                  @if (uploadData != '') {
                    <div class="errorsection">
                      <div class="errorfilenameParent"><i class="fa fa-file-text"></i>
                      @if (bulkOrderExcel) {
                        <div class="errorfilename">
                          <div>{{bulkOrderExcel.name}}</div>
                          <div>{{fileSize}}</div>
                        </div>
                      }
                      @if (uploadData == 'success') {
                        <div class="uploadingcancel uploadingremove" (click)="removeFile()"
                          > <img alt="" class=" floatLeft"
                        src="/assets/images/trashblackicon.png" width="24"></div>
                      }
                    </div>
                  </div>
                }
                @if (uploadData == 'success' && !showTryAgain) {
                  <div class="mt-5 After-uploadSucess">
                    <div class="uploadSubmit" (click)="handleOnUploadSubmit()">{{'startOrder.bulkorder.submitlabel' | cxTranslate}}</div>
                  </div>
                }
                <!-- img will be added here -->
                @if (uploadData == '' && showError1Msg) {
                  <div class="errorMessage" id="errorformat1">
                    <div><img alt="" class="circle-exclamation floatLeft"
                      src="../../assets/images/exclamation-circle.svg">
                    </div>
                    @if (uploadData == '' && showError1Msg) {
                      <div class="uploaderrormessage floatLeft" [innerHTML]="'startOrder.bulkorder.errormsg1' | cxTranslate">
                      </div>
                    }
                    <div class="clearfix"></div>
                  </div>
                }
                @if (showError1Msg || showTryAgain) {
                  <div class="tryagain" (click)="handleOnTryAgainBtnClick()">{{'startOrder.bulkorder.tryagain' | cxTranslate}}</div>
                }
                @if (uploadData == 'failure') {
                  <div class="errorMessage" id="errorformat2">
                    <div><img alt="" class="circle-exclamation floatLeft"
                      src="../../assets/images/exclamation-circle.svg">
                      <img alt="" class="circle-exclamation floatLeft">
                    </div>
                    <div class="uploaderrormessage floatleft" [innerHTML]="'startOrder.bulkorder.errormsg2' | cxTranslate">
                    </div>
                    <div class="clearfix"></div>
                  </div>
                }
                @if (uploadData == 'failure') {
                  <div   class="tryagain" (click)="handleOnTryAgainBtnClick()">{{'startOrder.bulkorder.tryagain' | cxTranslate}}</div>
                }
                @if (orderSubmitContent == 'failure') {
                  <div class="errorMessage" id="errorformat3">
                    @if (showError1Msg || (uploadData == 'failure')) {
                      <div class="tryagain" (click)="handleOnTryAgainBtnClick()">{{'startOrder.bulkorder.tryagain' | cxTranslate}}</div>
                    }
                    <img alt="" class="circle-exclamation floatLeft">
                    <div class="uploaderrormessage floatleft" [innerHTML]="'startOrder.bulkorder.errormsg3' | cxTranslate">
                    </div>
                    <div class="clearfix"></div>
                  </div>
                }
              </div>
            </div>
          }
          @if (orderSubmitContent == 'success') {
            <div class="col-xs-12 cart_bulkOrder-submittedmsg">
              <div class="cart_bulkOrder-msgHeader">{{'startOrder.bulkorder.thankyoutitle' | cxTranslate}}</div>
              <!-- sit changes -->
              <div class="cart_bulkOrder-msgBody" [innerHTML]="'startOrder.bulkorder.thankyoumsg' | cxTranslate">
              </div>
              <a routerLink="/orders/my-orders">
                <div class="cart_bulkOrdervieworder">{{'startOrder.bulkorder.viewOrder' | cxTranslate}}</div>
              </a>
            </div>
          }
        </div>
        <div class=" col-xs-12 d-block d-sm-block d-md-block d-lg-none d-xl-none cart_bulkOrder-mobile">
          <div class="col-xs-12 cart_bulkOrder-header">{{'startOrder.bulkorder.unavailabletxt' | cxTranslate}}</div>
          <div class="col-xs-12 cart_bulkOrder-MobileMsg">{{'startOrder.bulkorder.unavailablemsg' | cxTranslate}}</div>
          <div class="clearfix"></div>
          <a routerLink="/my-account">
            <div class="cart_bulkOrder-MobileButton">{{'startOrder.bulkorder.back2dashboard' | cxTranslate}}</div>
          </a>
        </div>
        <div class="clearfix"></div>
      </section>
    }
    <!-- bulk order page ends -->
  </div>
</div>

<!-- Delete Modal starts -->
<div id="cart_deletemodal" class="modal" role="dialog" tabindex="-1"
  aria-labelledby="forgotModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-body row">
        <h4 class="modal-title cart_deleteheader col-xs-11 col-lg-11">{{'startOrder.deletecarttitle' | cxTranslate}}</h4>
        <div class="no-padding pull-right col-lg-1"><span class="cart-delete_close" data-bs-dismiss="modal"
        aria-label="Close">×</span></div>
        <p class="cart_deletesubheader col-xs-12">
          {{'startOrder.deletecartmsg' | cxTranslate}}
        </p>
        <div class="clearboth"></div>
        <div class="cart_deletebuttons">
          <button class="cart_deleteYes global_redbtn" (click)="handleOnDeleteModelYesBtnClick()">{{'startOrder.yeslabel' | cxTranslate}}</button>
          <button type="button" class="cart_deleteNo global_greybtn" data-bs-dismiss="modal"
          #closeButton>{{'startOrder.nolabel' | cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Delete Modal ends -->
<!--Shipping Flexibility Product Page Start-->
@if (showShipFlexContent && orderLists) {
  <section class="shipping_flexibility" id="shipping_flexibility">
    <div class="col-xs-12" id="shipFlex_cart_section" class="shipFlex_cart_section" >
      <div class="col-xs-12 col-md-12 shipFlex_add_cart_wrapper" id="shipFlex_cart-wrapper-main">
        <div class="shipFlex">
          <div class="col-md-12 shipFlex_border_cart">
            <div class="shipFlex_support">
              <div class="shipFlex_ISI">
                <ul class="shipFLex_ISI_dropdown">
                  <li class="dropdown ShipFlex_dropdown">
                    <a id="shipFlex_dropISI" data-bs-toggle="dropdown" aria-expanded="false"
                      role="button" class="dropdown-toggle droppreb shipFlex_cart_pdf_link"><span
                      class="shipFlex_cart_pdf_text">{{'startOrder.addproduct.impsafetyinfo' |
                    cxTranslate}}</span>
                    <span class="glyphicon glyphicon-menu-down" style="top: 3px; left: 6px;"></span>
                  </a>
                  <ul aria-labelledby="shipFlex_dropISI" class="shipFlex_dropISI dropdown-menu">
                    <li>
                      <a href="/products/fluad" target="_blank"
                        class="shipFlex_cart_pdf_link"><span
                        class="shipFlex_cart_pdf_text">FLUAD®
                      {{'startOrder.addproduct.impsafetyinfo' |cxTranslate}}</span></a>
                    </li>
                    <li>
                      <a href="/products/flucelvax" target="_blank"
                        class="shipFlex_cart_pdf_link"><span
                        class="shipFlex_cart_pdf_text">FLUCELVAX®
                      {{'startOrder.addproduct.impsafetyinfo' | cxTranslate}}</span></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="shipFlex_codingBilling">
              <ul class="shipFLex_ISI_dropdown">
                <li class="dropdown ShipFlex_dropdown">
                  <a id="shipFlex_dropISI" data-bs-toggle="dropdown" aria-expanded="false"
                    role="button" class="dropdown-toggle droppreb shipFlex_cart_pdf_link"> <span
                    class="shipFlex_cart_pdf_text">{{'startOrder.addproduct.codingnbillguide' |
                  cxTranslate}}</span>
                  <span class="glyphicon glyphicon-menu-down" style="top: 3px; left: 6px;"></span>
                </a>
                <ul aria-labelledby="shipFlex_dropISI" class="shipFlex_dropISI dropdown-menu">
                  <li>
                    <a href="/flu-vaccine-resources/fluad-coding-billing" target="_blank"
                      class="shipFlex_cart_pdf_link"><span
                      class="shipFlex_cart_pdf_text">FLUAD®
                      {{'startOrder.addproduct.codingnbillguide' |
                    cxTranslate}}</span></a>
                  </li>
                  <li>
                    <a href="/flu-vaccine-resources/flucelvax-coding-billing" target="_blank"
                      class="shipFlex_cart_pdf_link"><span
                      class="shipFlex_cart_pdf_text">FLUCELVAX®
                      {{'startOrder.addproduct.codingnbillguide' |
                    cxTranslate}}</span></a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="shipFlex_PI">
            <ul class="shipFLex_ISI_dropdown">
              <li class="dropdown ShipFlex_dropdown">
                <a id="shipFlex_dropISI" data-bs-toggle="dropdown" aria-expanded="false"
                  role="button" class="dropdown-toggle droppreb shipFlex_cart_pdf_link"><span
                  class="shipFlex_cart_pdf_text">{{'startOrder.addproduct.prescribinginfo' |
                cxTranslate}}</span>
                <span class="glyphicon glyphicon-menu-down" style="top: 3px; left: 6px;"></span>
              </a>
              <ul aria-labelledby="shipFlex_dropISI" class="shipFlex_dropISI dropdown-menu">
                <li>
                  <a href="/FluadPrescribingInfoPDF" target="_blank"
                    class="shipFlex_cart_pdf_link"><span
                    class="shipFlex_cart_pdf_text">FLUAD®
                  {{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</span></a>
                </li>
                <li>
                  <a href="/FlucelvaxPrescribingInfoPDF" target="_blank"
                    class="shipFlex_cart_pdf_link"><span
                    class="shipFlex_cart_pdf_text">FLUCELVAX®
                  {{'startOrder.addproduct.prescribinginfo' | cxTranslate}}</span></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--Membership details start-->
      <div class="shipFlex_membership">
        <div class="shipFlex_topline"></div>
        @if (orderLists && (orderLists.membershipData.membershipStatus == 'Active') && !showPendingMessage) {
          <div style="overflow: hidden;" class="">
            @if (activeMembershipContent) {
              <div class="productmemberdetails reviewpagemembership no-margin-top">
                <p>
                  {{activeMembershipContent.title}}
                  <strong>{{orderLists.membershipData.currentMembership}}.</strong>
                </p>
                <p>{{pendingMembershipContent.text2}}</p>
                @if (!isModelnSuccess) {
                  <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Active">{{activeMembershipContent.text1}}</strong></p>
                }
                @if (isModelnSuccess) {
                  <div [innerHTML]="activeMembershipContent.content"></div>
                }
                @if (!isModelnSuccess) {
                  <div class="price_detail" [innerHTML]="activeMembershipContent.text2"></div>
                }
              </div>
            }
          </div>
        }
        @if (orderLists && orderLists.membershipData.membershipStatus == 'Pending' || showPendingMessage) {
          <div style="overflow: hidden;" class="">
            @if (pendingMembershipContent) {
              <div class="col-xs-12 productmemberdetails reviewpagemembership no-margin-top">
                <p>{{pendingMembershipContent.title}}</p>
                <p>{{pendingMembershipContent.text2}}</p>
                @if (isModelnSuccess) {
                  <p>
                    Prices shown reflect current
                    @if (orderLists.membershipData.currentMembership != 'flu360 Pricing') {
                      <span>{{orderLists.membershipData.currentMembership}} pricing.&nbsp;</span>
                    }
                    @if (orderLists.membershipData.currentMembership == 'flu360 Pricing') {
                      <span>{{orderLists.membershipData.currentMembership}}.&nbsp;</span>
                    }
                    <span [innerHTML]="pendingMembershipContent.content"></span>
                  </p>
                }
                @if (!isModelnSuccess) {
                  <p class="order_modeln_alert"><img class="" [src]="getImage(activeMembershipContent.productMediaPdf)"><strong class="order_Modeln_Alert_Pending">{{activeMembershipContent.text1}}</strong></p>
                }
                @if (!isModelnSuccess) {
                  <p class="price_detail" [innerHTML]="activeMembershipContent.text2"></p>
                }
              </div>
            }
          </div>
        }
        <div class="col-xs-12 memberline"></div>
        <div class="shipFlex_topbottomline"></div>
      </div>
      <!--Membership details end -->
      <!--Search Location start-->
      <div class="shipFlex_cart_customsearch">
        <i class="global_searchicon"></i><input type="search" #shipFlexSearch
        (keyup)="$event.keyCode == 13 ? applyShipFlexFilter(shipFlexSearch.value) : null"
        placeholder="Search for location" id="cart_searchbox">
        <button (click)="applyShipFlexFilter(shipFlexSearch.value)" class="shipFlex_searchbtn">{{'startOrder.searchlabel' | cxTranslate}}</button>
        <button class="shipFlex_resetbtn" id="shipFlex_resetbtn" (click)="resetShipFlexFilter(shipFlexSearch)">RESET</button>
      </div>
      <!--Search location End-->
      <!--Add Products list in the cart starts here -->
      @for (location of shipFlexFilteredLocations; track location; let locIndex = $index) {
        <div class="shipFlex_locProductDetails" id="shipFlex_locProductDetails" >
          <div class="col-md-12 shipFlex_border_cart shipFlex_productLocation">
            <div class="shipFlex_wrapper">
              <div class="shipFlex_accordian">
                <div class="col-md-1 shipFlex_pro_Desc_Accordion" id="shipFlex_pro_Desc_Accordion">
                  <button class="accordion-button collapsed bg-transparent border-0 shadow-none p-0" [class.collapsed]="!location.isExpanded" type="button"   (click)="toggleShipFlexAccordion(location); $event.stopPropagation()" [attr.aria-expanded]="location.isExpanded" [attr.aria-controls]="'shipFlex_productsBody' + getLocationOriginalIndex(location)"></button>
                </div>
              </div>
              <div class="shipFlex_locationDetail" id="shipFlex_locationDetail">
                <div class="shipFlex_locationDetail_Name">{{ location.locname }} </div>
                <div class="shipFlex_locationDetail_Adress">{{ location.address }}</div>
                <div class="shipFlex_locationDetail_State">{{ location.state }}</div>
              </div>
            </div>
            <div class="shipFlex_midLine d-none"></div>
            @if (seasonValue === 'inSeason' && ONSNEnabled) {
              <div class="shipFlex_deliveryQty_wrapper">
                <div class="shipFlex_deliveryDetail" >
                  <div class="shipFlex_deliveryDetail_estimate">Estimated delivery</div>
                  <div class="shipFlex_deliveryDetail_date"><input class="date-box"  type="text" [value]="(location.deliveryDate ? location.deliveryDate : confirmedDate) | date: 'EEEE, MMMM d, y'" readonly ></div>
                  <div class="shipFlex_deliveryDetail_rescheduleDate_btn reschedule-link" (click)="openCalendar('0_' + getLocationOriginalIndex(location), $event)">Reschedule delivery</div>
                  @if (openCalendarIndex ===('0_' + getLocationOriginalIndex(location))) {
                    <div class="calendar-backdrop" (click)="openCalendarIndex = null"></div>
                    <div  class="calendar-wrapper"  (click)="$event.stopPropagation()" >
                        <span class="calendar-arrow">
                          <img class="downward_triangle" alt="downwardtriangle" src="../../assets/images/downward_triangle.svg">
                        </span>
                        <div class="calendar-mobile-header d-none">
                          <span class="calendar-mobile-title">Reschedule delivery</span>
                          <span class="calendar-mobile-close" (click)="openCalendarIndex = null"><img class="calenderclose" alt="close icon" src="../../assets/images/close.png"></span>
                        </div>
                      <div class="custom-month-label">{{ monthLabel }}</div>
                      <mat-calendar #calendar [minDate]="minSelectableDate" [maxDate]="maxSelectableDate" [dateFilter]="dateFilter" [selected]="tempSelectedDates['0_' + getLocationOriginalIndex(location)]" (selectedChange)="onDateSelected('0_' + getLocationOriginalIndex(location), $event)"></mat-calendar>
                      <div class="calendar-info">
                        <mat-icon>info_outline</mat-icon>
                        {{ deliveryConfig.infoText }}
                      </div>
                      <button  mat-stroked-button color="primary" [disabled]="!tempSelectedDates['0_' + getLocationOriginalIndex(location)]"(click)="confirmDate('0_' + getLocationOriginalIndex(location), location)">Update Delivery </button>
                    </div>
                  }
                </div>
                <div class="shipFlex_totalCount">
                  <div class="shipFlex_totalQty">
                    <strong class="shipFlex_qty">{{'startOrder.addproduct.totalqty' |
                      cxTranslate}}<span class="count_qty">{{ getLocationTotalQty(getLocationOriginalIndex(location)) }}</span></strong>
                    </div>
                  </div>
                </div>
              }
              @if (seasonValue === 'prebook' || (seasonValue === 'inSeason' && !ONSNEnabled) ) {
                <div class="shipFlex_totalCount prebook_TotalCount">
                  <div class="shipFlex_totalQty">
                    <strong class="shipFlex_qty">{{'startOrder.addproduct.totalqty' |
                      cxTranslate}}<span class="count_qty">{{ getLocationTotalQty(getLocationOriginalIndex(location)) }}</span></strong>
                    </div>
                  </div>
                }
              </div>
              @if (location.isExpanded) {
                <div class="shipFlex_productsBody "  [id]="'shipFlex_productsBody' + getLocationOriginalIndex(location)">
                  @for (product of shipFlexProducts; track product; let pIdx = $index) {
                    <div class="col-md-12 shipFlex_productDetails">
                      <div class="shipFlex_productDetails_wrapper">
                        <div class="shipFlex_productLogo">
                          <img [alt]="product.baseName + ' logo'"
                            [src]="'../../assets/images/' + product.baseName + '.webp'">
                          </div>
                          <div class="shipFlex_productName_value">
                            <div class=" shipFlex_baseName"><span class="shipFlex_baseName1">{{product.baseName}}</span>&nbsp;({{product.presentationName}})</div>
                            <div class="shipFlex_cart_doses_value">{{product.priceData?.value | currency: product.priceData?.currency}} per unit | {{product.doses}} doses per unit
                            </div>
                            @if (!product.sellable) {
                              <div class="shipFlex_soldOut_label">SOLD OUT</div>
                            }
                          </div>
                        </div>
                        <div class="shipFlex_total_count col-md-3 col-xs-12">
                          <div class="shipFlex_total-order-txt">{{'startOrder.addproduct.totalcost' | cxTranslate}}</div>
                          <div class="shipFlex_cost_doses">
                            <div class=" shipFlex_total_cost_item">
                              <strong>@if (product.location[getLocationOriginalIndex(location)]?.locAmount) {
                                <span class="shipFlex_total_amnt">{{product.location[getLocationOriginalIndex(location)]?.locAmount}}</span>
                              }
                              @if (!product.location[getLocationOriginalIndex(location)]?.locAmount) {
                                <span class="shipFlex_total_amnt">{{'0.00' | currency: product.priceData.currency}}</span>
                              }</strong>
                            </div>
                            <div class="shipFlex_total_doses_item">
                              <strong><span class="total_doses">&nbsp;({{(product.location[getLocationOriginalIndex(location)]?.locDoses || 0) | number:'1.0'}}</span>&nbsp;doses)</strong>
                            </div>
                          </div>
                        </div>
                        <div class=" col-md-2 shipFlex_productQuantity">
                          <div class="shipFlexcart_inputUnit">
                            <input type="text" id="'shipFlex_input_' + pIdx + '_' + locIndex" name="'shipFlex_input_' + pIdx + '_' + locIndex" min="0" max="9999"
                              placeholder="0" class="form-control qty-messure shipFlex_input"
                              maxlength="4" [disabled]="!product.sellable" [(ngModel)]="product.location[getLocationOriginalIndex(location)].value"
                              (keyup)="handleOnShipFlexUnitChange($event, pIdx, getLocationOriginalIndex(location))">
                              <label class="shipFlex_cart_unitLabel"
                                [for]="'shipFlex_input_' + pIdx + '_' + locIndex"><span>units</span></label>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                <!--Add Products list in the cart End -->
                <!--Bottom Section started-->
                <div class="col-xs-12 shipFlex_bottomline"></div>
                <div class="col-md-12 shipFlex_bottomwrapper">
                  <!-- <div class="col-md-6 shipFlex_OrderInfo" [style.visibility]="(seasonValue === 'inSeason' && ONSNEnabled) ? 'visible' : 'hidden'">Order by 12 PM ET (Mon–Thu) for next business day
                  delivery. Otherwise, allow two business days. Business days exclude holidays.</div> -->
                  <div class="shipFlex_confirmbtn">
                    <button class="shipFlex_btn-confirm rvw_btn_enable"
                      (click)="handleOnShipFlexPlaceOrderBtnClick();scrollToTop()"
                      [disabled]="disableShipFlexPlaceOrderBtn()"> {{'startOrder.addproduct.reviewnplaceorder' |
                    cxTranslate}}</button>
                  </div>
                </div>
                <!--Bottom section Ended-->
              </div>
            </div>
          </div>
        </div>
      </section>
    }
    <!--Shipping Flexibility Product Page End-->

    @if(showPrePaymentPopup){
<div>
  <div
    id="prePaymentDisclaimerPopUP"
    class="modal show"
    tabindex="-1"
    role="dialog"
    data-bs-backdrop="static">

    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-body">

          <div class="prePaymentHeader">
            <p class="prePaymentHeading">
              {{ prePaymentTermsHeader }}
            </p>

            <div class="close_Btn"
            (click)="handlePrePaymentPopupClose()">&times;</div>
          </div>

          <p class="prePaymentText">
            {{ prePaymentTermsAndDescription }}
          </p>

          <div class="prePaymentBtnParent">
            <button class="prePaymentYesBtn"
            (click)="handleOnPrePaymentYes()">
              Yes
            </button>

            <button class="prePaymentNoBtn"
            (click)="handleOnPrePaymentNo()">
              No
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
}